import React, {Component} from "react";
import {Col, FormGroup, Row} from "react-bootstrap";
import UAFilterContainer from "../Common/UAFilterContainer";
import CommonSelector from "../Common/CommonSelector";
import FormInputs from "../Common/FormInputs";

const FormErrors = ({formErrors, fieldName}) =>
    <div className='row formErrors' aria-label={formErrors[fieldName]}>
        <p className="form-validation-error"> {formErrors[fieldName]}</p>
    </div>

class ProjectFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            appFocused: false,
            moduleFocused: false,
            bpFocused: false
        };
    }

    handleApplicationsOnChange = (selectedValue) => {
        this.props.handleApplicationsOnChange(selectedValue);
    };

    handleApplicationsInputChange = (inputValue) => {
        this.props.handleApplicationsInputChange(inputValue);
    };


    handleModulesOnChange = (selectedValue) => {
        this.props.handleModulesOnChange(selectedValue);
    };

    handleModulesInputChange = (inputValue) => {
        this.props.handleModulesInputChange(inputValue);
    };

    handleFieldChange = (fieldName) => (e) => {
        const value = e.target?.value ?? e; // supports both native and custom inputs
        this.props.handleInputChange(fieldName, value);
    };

    resetOptions = (event, filterName) => {
        if (filterName === "application") {
            let appForReset = this.state.unSelectedApps;
            if (appForReset) appForReset = [];
            this.setState({
                unSelectedApps: appForReset
            });
        } else
            this.props.resetOptions(event, filterName);
    };

    render() {
        const {applicationSelected, moduleSelected, applicationOptions, moduleOptions, userAttributeFilters, handleUserAttributesUpdate,
            annualFTECost, annualFTEHours, LTNonError, LTSysError, LTUserError, LTUncatMessage ,projectDuration, projectUser, testEffortPerModule,formErrors,
            inputClass_annualFTECost, inputClass_annualFTEHours, inputClass_LTNonError, inputClass_LTSysError, inputClass_LTUserError, inputClass_LTUncatMessage, inputClass_projectDuration, inputClass_projectUser,
            inputClass_testEffortPerModule,trans} = this.props;

        let appValue = applicationSelected ? applicationSelected.filter(x => x.selected === true) : [];
        let appOptions = applicationOptions ? applicationOptions : [];
        let modValue = moduleSelected ? moduleSelected.filter(x => x.selected === true) : [];
        let modOptions = moduleOptions ? moduleOptions : [];

        return (
            <Row>
                <Col md={{ span: 10, offset: 1 }}>
                    <FormGroup role="group" aria-labelledby="projectFilters_head">
                        <h4 id="projectFilters_head" className="knoa-region" tabIndex="-1">
                            {trans('project:projectFilters')}
                        </h4>

                        <div role="group" aria-labelledby="applicationFilters_head">
                            <h5 id="applicationFilters_head">{trans('preferences:applicationFilters')}</h5>

                            <Row className="mb-3 align-items-stretch">
                                <Col md={3} className="card-row-col-label">
                                    <label htmlFor="Applications" className="col-control-sr-label">
                                        {trans('preferences:applications')}
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <CommonSelector
                                        inputId="Applications"
                                        isCreatable
                                        style="typetosearch"
                                        componentLocation="normal"
                                        name="applicationsSelect"
                                        placeholder={this.state.appFocused ? "" : trans('common:typeToSearch')}
                                        value={appValue}
                                        options={appOptions}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        onChange={this.handleApplicationsOnChange}
                                        onInputChange={this.handleApplicationsInputChange}
                                        onMenuClose={(e) => this.resetOptions(e, "application")}
                                        onFocus={() => this.setState({ appFocused: true })}
                                        onBlur={() => this.setState({ appFocused: false })}
                                        isClearable
                                        isSearchable
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3 stretch">
                                <Col md={3} className="card-row-col-label">
                                    <label htmlFor="modules" className="col-control-sr-label">
                                        {trans('preferences:modules')}
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <CommonSelector
                                        inputId="modules"
                                        isCreatable
                                        style="typetosearch"
                                        componentLocation="normal"
                                        name="modulesSelect"
                                        placeholder={this.state.moduleFocused ? "" : trans('common:typeToSearch')}
                                        value={modValue}
                                        options={modOptions}
                                        getOptionLabel={(option) => option.label}
                                        getOptionValue={(option) => option.value}
                                        onChange={this.handleModulesOnChange}
                                        onInputChange={this.handleModulesInputChange}
                                        onMenuClose={(e) => this.resetOptions(e, "module")}
                                        onFocus={() => this.setState({ moduleFocused: true })}
                                        onBlur={() => this.setState({ moduleFocused: false })}
                                        isClearable
                                        isSearchable
                                    />
                                </Col>
                            </Row>
                        </div>

                        <div role="group" aria-labelledby="userAttributes_head">
                            <h5 id="userAttributes_head">{trans('preferences:userAttributes')}</h5>
                            <UAFilterContainer
                                userAttributesOptions={userAttributeFilters}
                                handleUserAttributesUpdate={handleUserAttributesUpdate}
                                translate={trans}
                            />
                        </div>

                        <div role="group" aria-labelledby="projectParameters_head">
                            <h4 id="projectParameters_head" className="knoa-region" tabIndex="-1">
                                {trans('project:projectParameters')}
                            </h4>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="annualFTECost" className="col-control-sr-label">
                                        {trans('preferences:annualFTECost')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "annualFTECost",
                                                    className: inputClass_annualFTECost,
                                                    placeholder: "",
                                                    value: annualFTECost.value,
                                                    onChange: this.handleFieldChange("annualFTECost"),
                                                    id: "annualFTECost",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="annualFTECost" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="annualFTEHours" className="col-control-sr-label">
                                        {trans('preferences:annualFTEHours')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "annualFTEHours",
                                                    className: inputClass_annualFTEHours,
                                                    placeholder: "",
                                                    value: annualFTEHours.value,
                                                    onChange: this.handleFieldChange("annualFTEHours"),
                                                    id: "annualFTEHours",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="annualFTEHours" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="LTNonError" className="col-control-sr-label">
                                        {trans('preferences:LTNonError')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "LTNonError",
                                                    className: inputClass_LTNonError,
                                                    placeholder: "",
                                                    value: LTNonError.value,
                                                    onChange: this.handleFieldChange("LTNonError"),
                                                    id: "LTNonError",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="LTNonError" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="LTSysError" className="col-control-sr-label">
                                        {trans('preferences:LTSysError')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "LTSysError",
                                                    className: inputClass_LTSysError,
                                                    placeholder: "",
                                                    value: LTSysError.value,
                                                    onChange: this.handleFieldChange("LTSysError"),
                                                    id: "LTSysError",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="LTSysError" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="LTUserError" className="col-control-sr-label">
                                        {trans('preferences:LTUserError')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "LTUserError",
                                                    className: inputClass_LTUserError,
                                                    placeholder: "",
                                                    value: LTUserError.value,
                                                    onChange: this.handleFieldChange("LTUserError"),
                                                    id: "LTUserError",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="LTUserError" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="LTUncatMessage" className="col-control-sr-label">
                                        {trans('preferences:LTUncatMessage')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "LTUncatMessage",
                                                    className: inputClass_LTUncatMessage,
                                                    placeholder: "",
                                                    value: LTUncatMessage.value,
                                                    onChange: this.handleFieldChange("LTUncatMessage"),
                                                    id: "LTUncatMessage",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="rror-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="LTUncatMessage" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="projectDuration" className="col-control-sr-label">
                                        {trans('preferences:projectDuration')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "projectDuration",
                                                    className: inputClass_projectDuration,
                                                    placeholder: "",
                                                    value: projectDuration.value,
                                                    onChange: this.handleFieldChange("projectDuration"),
                                                    id: "projectDuration",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="projectDuration" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="projectUser" className="col-control-sr-label">
                                        {trans('preferences:projectUser')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "projectUser",
                                                    className: inputClass_projectUser,
                                                    placeholder: "",
                                                    value: projectUser.value,
                                                    onChange: this.handleFieldChange("projectUser"),
                                                    id: "projectUser",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="projectUser" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row className="row-with-error align-items-stretch">
                                <Col className="card-row-col-label" md={2}>
                                    <label htmlFor="testEffortPerModule" className="col-control-sr-label">
                                        {trans('preferences:testEffortPerModule')} <span className="text-danger-1">*</span>
                                    </label>
                                </Col>
                                <Col md={6} className="card-row-col-right">
                                    <div className="input-with-error">
                                        <FormInputs
                                            ncols={["col-12"]}
                                            proprieties={[
                                                {
                                                    type: "text",
                                                    name: "testEffortPerModule",
                                                    className: inputClass_testEffortPerModule,
                                                    placeholder: "",
                                                    value: testEffortPerModule.value,
                                                    onChange: this.handleFieldChange("testEffortPerModule"),
                                                    id: "testEffortPerModule",
                                                    required: true,
                                                },
                                            ]}
                                        />
                                        <div className="error-placeholder">
                                            <FormErrors formErrors={formErrors} fieldName="testEffortPerModule" />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
        );
    }
}

export default ProjectFilters;